export const pingPageView = () => {
  // This is all specific to our page on Google analytics.
  const trackingId = 'UA-174141488-1'
  const fullPath = window.location.pathname + window.location.search
  // @ts-ignore
  window.gtag('config', trackingId, { page_path: fullPath })
}
